<template>
  <div>
    <v-form>
      <v-row dense>
        <v-col>
          <v-select dense hide-details outlined :items="testListItems" label="Select1">

          </v-select>
        </v-col>
        <v-col>
          <v-text-field label="Test 1" dense hide-details outlined></v-text-field>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col>
          <v-select dense hide-details outlined :items="testListItems" label="Select 2">

          </v-select>
        </v-col>
        <v-col>
          <v-text-field label="Test 2" dense hide-details outlined></v-text-field>
        </v-col>
      </v-row>          
      </v-form>
    <v-divider></v-divider>

    <v-slide-group       
      multiple
      show-arrows>
      <v-data-table
        v-model="selectedRows"
        @current-items="current = $event"
        @item-selected="bulkSelect"
        :headers="headers"
        :items="desserts"
        item-key="name"
        show-select
        class="elevation-1"
      >
      <!-- <template v-slot:body="{ desserts }">
        <v-slide-group       
          multiple
          show-arrows>
        </v-slide-group>
      </template> -->
      
      </v-data-table>
    </v-slide-group>

      <v-divider></v-divider>

      <!-- Dialog Card testing -->
      <v-row>
        <v-col>
          <dialog-card title="UI.Core Dialog" :fullscreen="false" :ok="testNotification" v-model="settingsDialog" :cancel="close">
            <v-btn dark slot="activator">
                UI.Core Dialog
            </v-btn>
            <div>Test Content</div>
          </dialog-card>
        </v-col>
        <v-col>
          <v-dialog v-model="dialog" max-width="70%">
            <template v-slot:activator="{ on, attrs }">
              <v-btn dark
                v-bind="attrs"
                v-on="on"
                >Default v-dialog</v-btn
              >
            </template>
            <!-- Display status / error messages coming from api -->
            <v-card>
              <v-card-title>
                <span class="headline">Test</span>
                <v-spacer></v-spacer>
                <v-icon @click="close()">mdi-close</v-icon>
              </v-card-title>
              <v-card-text>
                Test Content
              </v-card-text>
              <v-card-actions>
                <v-btn color="blue darken-1" text @click="close()">{{
                  "Cancel"
                }}</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="primary" dark class="mb-2" @click="testNotification()">{{
                  "TEST"
                }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>    
        </v-col>
        <v-col>
          <v-btn dark  @click="clickMe()">Click Me</v-btn>
        </v-col>
      </v-row>        
      
  </div>
</template>

<script>
import uiView from "@/_mixins/ui-view-mixin";
import dialogCard from "@/_components/shared/dialog-card"
import notificationMixin from "@/_mixins/notification-mixin";

export default {
  name: "DataTableTest",
  mixins: [uiView, notificationMixin],
  components: {dialogCard},
  props: {},
  watch: {},
  created() {
    // const self = this;
    // self.keyDownHandler = function ({ key }) {
    //   if (key == "Shift") self.shiftKeyOn = true;
    // };
    // self.keyUpHandler = function ({ key }) {
    //   if (key == "Shift") self.shiftKeyOn = false;
    // };
    // window.addEventListener("keydown", this.keyDownHandler);
    // window.addEventListener("keyup", this.keyUpHandler);
  },
  beforeDestroy() {
    // window.removeEventListener("keydown", this.keyDownHandler);
    // window.removeEventListener("keyup", this.keyUpHandler);
  },  
  mounted() {
    // this.globalSnackbar = false;
  },
  computed(){
    
  },
  data: () => ({
    // showNotification: this.globalNotification.snackbar === null ? false : true,
    shiftKeyOn: false,
    dialog: false,
    settingsDialog: false,
    lastUnselected: null,
    lastSelected: null,
    current: [],
    selectedRows: [],
    singleSelect: false,
    selected: [],
    headers: [
      {
        text: 'Dessert (100g serving)',
        align: 'start',
        sortable: false,
        value: 'name',
      },
      { text: 'Calories', value: 'calories' },
      { text: 'Fat (g)', value: 'fat' },
      { text: 'Carbs (g)', value: 'carbs' },
      { text: 'Protein (g)', value: 'protein' },
      { text: 'Iron (%)', value: 'iron' },
      { text: 'Test 1', value: 'test1' },
      { text: 'Test 2', value: 'test2' },
      { text: 'Test 3', value: 'test3' },
      { text: 'Test 4', value: 'test4' },
      { text: 'Test 5', value: 'test1' },
      { text: 'Test 6', value: 'test1' },
      { text: 'Test 7', value: 'test1' },
      { text: 'Test 8', value: 'test1' },
      { text: 'Test 9', value: 'test1' },
      { text: 'Test 10', value: 'test1' },
      { text: 'Test 11', value: 'test1' },
      { text: 'Test 12', value: 'test1' },
      { text: 'Test 13', value: 'test1' },
    ],
    desserts: [
      {
        name: 'Frozen Yogurt',
        calories: 159,
        fat: 6.0,
        carbs: 24,
        protein: 4.0,
        iron: '1%',
        test1: '1111111111 1111111111 111111111',
        test2: '2222222222 222222222 22222222',
        test3: '333333333 333333333 33333333333 3333333',
        test4: '4',
        test5: '5',
      },
      {
        name: 'Ice cream sandwich',
        calories: 237,
        fat: 9.0,
        carbs: 37,
        protein: 4.3,
        iron: '1%',
        test1: '1111111111 1111111111 111111111',
        test2: '2222222222 222222222 22222222',
        test3: '333333333 333333333 33333333333 3333333',
        test4: '4',
        test5: '5',
      },
      {
        name: 'Eclair',
        calories: 262,
        fat: 16.0,
        carbs: 23,
        protein: 6.0,
        iron: '7%',
        test1: '1111111111 1111111111 111111111',
        test2: '2222222222 222222222 22222222',
        test3: '333333333 333333333 33333333333 3333333',
        test4: '4',
        test5: '5',
      },
      {
        name: 'Cupcake',
        calories: 305,
        fat: 3.7,
        carbs: 67,
        protein: 4.3,
        iron: '8%',
        test1: '1111111111 1111111111 111111111',
        test2: '2222222222 222222222 22222222',
        test3: '333333333 333333333 33333333333 3333333',
        test4: '4',
        test5: '5',
      },
      {
        name: 'Gingerbread',
        calories: 356,
        fat: 16.0,
        carbs: 49,
        protein: 3.9,
        iron: '16%',
        test1: '1111111111 1111111111 111111111',
        test2: '2222222222 222222222 22222222',
        test3: '333333333 333333333 33333333333 3333333',
        test4: '4',
        test5: '5',
      },
      {
        name: 'Jelly bean',
        calories: 375,
        fat: 0.0,
        carbs: 94,
        protein: 0.0,
        iron: '0%',
        test1: '1111111111 1111111111 111111111',
        test2: '2222222222 222222222 22222222',
        test3: '333333333 333333333 33333333333 3333333',
        test4: '4',
        test5: '5',
      },
      {
        name: 'Lollipop',
        calories: 392,
        fat: 0.2,
        carbs: 98,
        protein: 0,
        iron: '2%',
        test1: '1111111111 1111111111 111111111',
        test2: '2222222222 222222222 22222222',
        test3: '333333333 333333333 33333333333 3333333',
        test4: '4',
        test5: '5',
      },
      {
        name: 'Honeycomb',
        calories: 408,
        fat: 3.2,
        carbs: 87,
        protein: 6.5,
        iron: '45%',
        test1: '1111111111 1111111111 111111111',
        test2: '2222222222 222222222 22222222',
        test3: '333333333 333333333 33333333333 3333333',
        test4: '4',
        test5: '5',
      },
      {
        name: 'Donut',
        calories: 452,
        fat: 25.0,
        carbs: 51,
        protein: 4.9,
        iron: '22%',
        test1: '1111111111 1111111111 111111111',
        test2: '2222222222 222222222 22222222',
        test3: '333333333 333333333 33333333333 3333333',
        test4: '4',
        test5: '5',
      },
      {
        name: 'KitKat',
        calories: 518,
        fat: 26.0,
        carbs: 65,
        protein: 7,
        iron: '6%',
        test1: '1111111111 1111111111 111111111',
        test2: '2222222222 222222222 22222222',
        test3: '333333333 333333333 33333333333 3333333',
        test4: '4',
        test5: '5',
      },
      {
        name: 'KitKat1',
        calories: 518,
        fat: 26.0,
        carbs: 65,
        protein: 7,
        iron: '6%',
        test1: '1111111111 1111111111 111111111',
        test2: '2222222222 222222222 22222222',
        test3: '333333333 333333333 33333333333 3333333',
        test4: '4',
        test5: '5',
      },
      {
        name: 'KitKat2',
        calories: 518,
        fat: 26.0,
        carbs: 65,
        protein: 7,
        iron: '6%',
        test1: '1111111111 1111111111 111111111',
        test2: '2222222222 222222222 22222222',
        test3: '333333333 333333333 33333333333 3333333',
        test4: '4',
        test5: '5',
      },
      {
        name: 'KitKat3',
        calories: 518,
        fat: 26.0,
        carbs: 65,
        protein: 7,
        iron: '6%',
        test1: '1111111111 1111111111 111111111',
        test2: '2222222222 222222222 22222222',
        test3: '333333333 333333333 33333333333 3333333',
        test4: '4',
        test5: '5',
      },
      {
        name: 'KitKat4',
        calories: 518,
        fat: 26.0,
        carbs: 65,
        protein: 7,
        iron: '6%',
        test1: '1111111111 1111111111 111111111',
        test2: '2222222222 222222222 22222222',
        test3: '333333333 333333333 33333333333 3333333',
        test4: '4',
        test5: '5',
      },
      {
        name: 'KitKat5',
        calories: 518,
        fat: 26.0,
        carbs: 65,
        protein: 7,
        iron: '6%',
        test1: '1111111111 1111111111 111111111',
        test2: '2222222222 222222222 22222222',
        test3: '333333333 333333333 33333333333 3333333',
        test4: '4',
        test5: '5',
      },
      {
        name: 'KitKat6',
        calories: 518,
        fat: 26.0,
        carbs: 65,
        protein: 7,
        iron: '6%',
        test1: '1111111111 1111111111 111111111',
        test2: '2222222222 222222222 22222222',
        test3: '333333333 333333333 33333333333 3333333',
        test4: '4',
        test5: '5',
      },
      {
        name: 'KitKat7',
        calories: 518,
        fat: 26.0,
        carbs: 65,
        protein: 7,
        iron: '6%',
        test1: '1111111111 1111111111 111111111',
        test2: '2222222222 222222222 22222222',
        test3: '333333333 333333333 33333333333 3333333',
        test4: '4',
        test5: '5',
      },
      {
        name: 'KitKat8',
        calories: 518,
        fat: 26.0,
        carbs: 65,
        protein: 7,
        iron: '6%',
        test1: '1111111111 1111111111 111111111',
        test2: '2222222222 222222222 22222222',
        test3: '333333333 333333333 33333333333 3333333',
        test4: '4',
        test5: '5',
      },
      {
        name: 'KitKat9',
        calories: 518,
        fat: 26.0,
        carbs: 65,
        protein: 7,
        iron: '6%',
        test1: '1111111111 1111111111 111111111',
        test2: '2222222222 222222222 22222222',
        test3: '333333333 333333333 33333333333 3333333',
        test4: '4',
        test5: '5',
      },
      {
        name: 'KitKat10',
        calories: 518,
        fat: 26.0,
        carbs: 65,
        protein: 7,
        iron: '6%',
        test1: '1111111111 1111111111 111111111',
        test2: '2222222222 222222222 22222222',
        test3: '333333333 333333333 33333333333 3333333',
        test4: '4',
        test5: '5',
      },
      {
        name: 'KitKat11',
        calories: 518,
        fat: 26.0,
        carbs: 65,
        protein: 7,
        iron: '6%',
        test1: '1111111111 1111111111 111111111',
        test2: '2222222222 222222222 22222222',
        test3: '333333333 333333333 33333333333 3333333',
        test4: '4',
        test5: '5',
      },
      {
        name: 'KitKat12',
        calories: 518,
        fat: 26.0,
        carbs: 65,
        protein: 7,
        iron: '6%',
        test1: '1111111111 1111111111 111111111',
        test2: '2222222222 222222222 22222222',
        test3: '333333333 333333333 33333333333 3333333',
        test4: '4',
        test5: '5',
      },
      {
        name: 'KitKat13',
        calories: 518,
        fat: 26.0,
        carbs: 65,
        protein: 7,
        iron: '6%',
        test1: '1111111111 1111111111 111111111',
        test2: '2222222222 222222222 22222222',
        test3: '333333333 333333333 33333333333 3333333',
        test4: '4',
        test5: '5',
      },
      {
        name: 'KitKat14',
        calories: 518,
        fat: 26.0,
        carbs: 65,
        protein: 7,
        iron: '6%',
        test1: '1111111111 1111111111 111111111',
        test2: '2222222222 222222222 22222222',
        test3: '333333333 333333333 33333333333 3333333',
        test4: '4',
        test5: '5',
      },
      {
        name: 'KitKat15',
        calories: 518,
        fat: 26.0,
        carbs: 65,
        protein: 7,
        iron: '6%',
        test1: '1111111111 1111111111 111111111',
        test2: '2222222222 222222222 22222222',
        test3: '333333333 333333333 33333333333 3333333',
        test4: '4',
        test5: '5',
      },
      {
        name: 'KitKat16',
        calories: 518,
        fat: 26.0,
        carbs: 65,
        protein: 7,
        iron: '6%',
        test1: '1111111111 1111111111 111111111',
        test2: '2222222222 222222222 22222222',
        test3: '333333333 333333333 33333333333 3333333',
        test4: '4',
        test5: '5',
      },
      {
        name: 'KitKat17',
        calories: 518,
        fat: 26.0,
        carbs: 65,
        protein: 7,
        iron: '6%',
        test1: '1111111111 1111111111 111111111',
        test2: '2222222222 222222222 22222222',
        test3: '333333333 333333333 33333333333 3333333',
        test4: '4',
        test5: '5',
      },
      {
        name: 'KitKat18',
        calories: 518,
        fat: 26.0,
        carbs: 65,
        protein: 7,
        iron: '6%',
        test1: '1111111111 1111111111 111111111',
        test2: '2222222222 222222222 22222222',
        test3: '333333333 333333333 33333333333 3333333',
        test4: '4',
        test5: '5',
      },
      {
        name: 'KitKat19',
        calories: 518,
        fat: 26.0,
        carbs: 65,
        protein: 7,
        iron: '6%',
        test1: '1111111111 1111111111 111111111',
        test2: '2222222222 222222222 22222222',
        test3: '333333333 333333333 33333333333 3333333',
        test4: '4',
        test5: '5',
      },
      {
        name: 'KitKat20',
        calories: 518,
        fat: 26.0,
        carbs: 65,
        protein: 7,
        iron: '6%',
        test1: '1111111111 1111111111 111111111',
        test2: '2222222222 222222222 22222222',
        test3: '333333333 333333333 33333333333 3333333',
        test4: '4',
        test5: '5',
      },                                                                                                                        
    ],
    testListItems: ["Test1", "Test2", "Test3", "Test4", "Test5"]
  }),
  methods: {
    dialogOk() {
      alert("Ok");
    },
    clickMe(){
      this.addNotification("User Preference Data Saved Successfully..");
    },
    close(){
      this.dialog = false;
      this.settingsDialog = false;
      this.addNotification("Success");
    },
    testNotification(){
      this.addNotification({
        type: "error", 
        message: "Error",
        description: "This message will be closed within 10 seconds",
        delay: 10000,
        top: true,
        right: true,
      });
    },
    bulkSelect({ item: b, value }) {
      // const { selectedRows, current, shiftKeyOn } = this;
      
      // debugger;
      // if (selectedRows.length > 0 && shiftKeyOn) {
      //   const a = value ? this.lastSelected : this.lastUnselected;
      //   let start = current.findIndex((item) => item == a);
      //   let end = current.findIndex((item) => item == b);
      //   if (start - end > 0) {
      //     let temp = start;
      //     start = end;
      //     end = temp;
      //   }
      //   if(value){
      //     for (let i = start; i <= end; i++) {
      //       selectedRows.push(current[i]);
      //     }
      //   }
      //   else selectedRows.splice(start, end-start);
        
      // }

      // if(!value) this.lastUnselected = b;
      // else this.lastSelected = b;
    }    
  },
};
</script>
<style lang="scss">
.v-text-field, .v-text-field * {
    line-height: 15px;
    padding: 1px 0 1px;
}

.v-input input {
    max-height: 15px;
}

</style>
